// extracted by mini-css-extract-plugin
export default {"error":"error__W6CBTFZ7","label":"label__s32o_xBh"};